<template>
  <div>
    <el-card>
      <el-form :inline="true" label-width="120px" size="small">
        <el-form-item>
          <b>轮播图(1000*1000)</b>
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(item, index) in bannerList"
                :key="index"
              >
                <span class="xuhao"
                  >{{ index + 1 }}、<el-button
                    type="primary"
                    size="mini"
                    plain
                    v-if="item.imgUrl"
                    @click="deleteImg(item)"
                    >删除</el-button
                  ></span
                >

                <img
                  :src="item.imgUrl"
                  alt=""
                  v-if="item.sort"
                  @click="addImg(1, index)"
                />
                <el-button
                  size="mini"
                  style="width: 90px"
                  type="primary"
                  @click="addImg(1, index)"
                  v-if="item.imgUrl == ''"
                  >添加图片</el-button
                >
              </div>
            </div>
            <!-- 如果需要导航按钮 -->
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
          </div>

          <!-- <el-table
            :data="list.imgList"
            :header-cell-style="getRowClass"
            border
            ref="multipleTable"
            style="width: 100%; flex: auto; margin-top: 20px"
            tooltip-effect="light"
          >
            <el-table-column
              prop="imgUrl"
              label="封面图"
              align="center"
              width="200"
            >
              <template slot-scope="{ row }">
                <img :src="row.imgUrl" alt="" style="height: 50px" />
              </template>
            </el-table-column>
            <el-table-column prop="imgType" label="类型" align="center">
              <template slot-scope="{ row }">
                <span v-if="row.imgType == 1">轮播图</span>
                <span v-if="row.imgType == 2">详情图</span>
              </template>
            </el-table-column>
            <el-table-column prop="sort" label="权重" align="center">
            </el-table-column>
          </el-table> -->
        </el-form-item>
      </el-form>
    </el-card>
    <!-- 属性 -->
    <el-card style="margin-top: 20px">
      <el-form :inline="true" label-width="120px" size="small">
        <el-form-item>
          <el-button
            size="mini"
            style="width: 90px"
            type="primary"
            @click="addAttribute"
            >添加属性</el-button
          >
          <el-table
            :data="list.keyList"
            :header-cell-style="getRowClass"
            border
            ref="multipleTable"
            style="width: 100%; flex: auto; margin-top: 20px"
            tooltip-effect="light"
          >
            <el-table-column
              prop="keyName"
              label="属性"
              align="center"
              width="200"
            >
            </el-table-column>
            <el-table-column
              prop="valuesList"
              label="值"
              align="center"
              width="200"
            >
              <template slot-scope="{ row }">
                <p v-for="(item, index) in row.valuesList" :key="index">
                  {{ item.valuesName }}
                </p>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              class-name="small-padding fixed-width"
              label="操作"
              fixed="right"
            >
              <template slot-scope="{ row }">
                <div class="done">
                  <el-button
                    size="mini"
                    style="width: 90px; margin: 0 0 10px 10px"
                    type="primary"
                    @click="addSpuValue(row)"
                    >添加</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
    </el-card>

    <!--  sku -->
    <el-card style="margin-top: 20px">
      <el-form :inline="true" label-width="120px" size="small">
        <el-form-item>
          <el-button
            size="mini"
            style="width: 90px"
            type="primary"
            @click="addSKU"
            >添加SKU</el-button
          >
          <el-table
            :data="list.skuList"
            :header-cell-style="getRowClass"
            border
            ref="multipleTable"
            style="width: 100%; flex: auto; margin-top: 20px"
            tooltip-effect="light"
          >
            <el-table-column
              prop="attribute"
              label="属性"
              align="center"
              width="200"
            >
            </el-table-column>

            <el-table-column
              prop="price"
              label="价格"
              align="center"
              width="200"
            >
            </el-table-column>

            <el-table-column
              prop="stock"
              label="库存"
              align="center"
              width="200"
            >
            </el-table-column>
            <el-table-column
              align="center"
              class-name="small-padding fixed-width"
              label="操作"
              fixed="right"
            >
              <template slot-scope="{ row }">
                <div class="done">
                  <el-button
                    size="mini"
                    style="width: 90px; margin: 0 0 10px 10px"
                    type="success"
                    v-if="row.deleteStatus == 0"
                    @click="shelves(row, 1)"
                    >上架</el-button
                  >

                  <el-button
                    size="mini"
                    style="width: 90px; margin: 0 0 10px 10px"
                    type="warning"
                    @click="shelves(row, 0)"
                    v-if="row.deleteStatus == 1"
                    >下架</el-button
                  >
                  <el-button
                    size="mini"
                    style="width: 90px; margin: 0 0 10px 10px"
                    type="primary"
                    @click="changeSku(row)"
                    >修改</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 详情图 -->
    <el-card style="margin-top: 20px">
      <b>详情图(750*???)</b>
      <div style="margin-top: 20px">
        <div
          v-for="(item, index) in detailImgList"
          :key="index"
          style="position: relative"
        >
          <span class="detailXuhao"
            >{{ index + 1 }}、<el-button
              type="primary"
              size="mini"
              plain
              v-if="item.imgUrl"
              @click="deleteImg(item)"
              >删除</el-button
            >
          </span>
          <img
            :src="item.imgUrl"
            alt=""
            v-if="item.sort"
            style="width: 350px; margin-left: 70px"
            @click="addImg(2, index)"
          />
          <div
            v-if="item.imgUrl == ''"
            style="
              width: 350px;
              height: 350px;
              margin-left: 70px;
              text-align: center;
              border: 1px dashed #ccc;
              line-height: 350px;
            "
          >
            <el-button
              size="mini"
              style="width: 90px"
              type="primary"
              @click="addImg(2, index)"
              >添加图片</el-button
            >
          </div>
        </div>
      </div>
    </el-card>

    <!-- 添加图片 -->
    <a-modal v-model="imgVisibile" title="spu添加图片" :footer="null">
      <el-form label-width="90px">
        <el-form-item label="选择图片">
          <el-upload
            class="avatar-uploader"
            name="img"
            :action="serverUrl"
            :headers="header"
            :auto-upload="true"
            :show-file-list="false"
            :on-success="upSuccess"
          >
            <img
              v-if="this.addImgOptinos.imgUrl"
              :src="this.addImgOptinos.imgUrl"
              class="avatar"
              style="width: 150px; height: auto"
            />

            <i
              :class="
                loadUpt
                  ? 'el-icon-loading'
                  : 'el-icon-plus avatar-uploader-icon'
              "
              style="margintop: 10px; font-size: 50px"
              v-else
            ></i>
          </el-upload>
        </el-form-item>
        <!-- <el-form-item label="类型">
          <el-radio v-model="addImgOptinos.imgType" label="1">轮播图</el-radio>
          <el-radio v-model="addImgOptinos.imgType" label="2">详情图</el-radio>
        </el-form-item> -->
        <!-- <el-form-item label="权重">
          <el-col :span="10">
            <el-input
              v-model="addImgOptinos.sort"
              placeholder="请输入内容"
            ></el-input>
          </el-col>
        </el-form-item> -->
      </el-form>
      <el-button type="primary" size="small" @click="sureImgAdd"
        >确定</el-button
      >
    </a-modal>
    <!-- 添加属性 -->
    <a-modal v-model="attributeVisibile" title="添加属性" :footer="null">
      <el-form label-width="90px">
        <el-form-item label="属性">
          <el-col :span="10">
            <el-input
              v-model="attributeOptions.keyName"
              placeholder="请输入内容"
            ></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <el-button type="primary" size="small" @click="sureAttributeAdd"
        >确定</el-button
      >
    </a-modal>
    <!-- 给 spu 添加属性 的 值 -->
    <a-modal v-model="spuVisibile" title="添加属性的值" :footer="null">
      <el-form label-width="90px">
        <el-form-item label="值">
          <el-col :span="10">
            <el-input
              v-model="spuOptions.valuesName"
              placeholder="请输入内容"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="图片">
          <el-upload
            class="avatar-uploader"
            name="img"
            :action="serverUrl"
            :headers="header"
            :auto-upload="true"
            :show-file-list="false"
            :on-success="spuImgSuccess"
          >
            <img
              v-if="spuOptions.valuesImg"
              :src="spuOptions.valuesImg"
              class="avatar"
              style="width: 150px; height: auto"
            />

            <i
              :class="
                loadUpt
                  ? 'el-icon-loading'
                  : 'el-icon-plus avatar-uploader-icon'
              "
              style="margintop: 10px; font-size: 50px"
              v-else
            ></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="权重">
          <el-col :span="10">
            <el-input
              v-model="spuOptions.sort"
              placeholder="请输入内容"
              type="number"
            ></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <el-button type="primary" size="small" @click="spuValueAdd"
        >确定</el-button
      >
    </a-modal>
    <!-- SKU -->
    <a-modal
      v-model="skuVisibile"
      title="添加SKU"
      :footer="null"
      @cancel="cancelSku"
    >
      <el-form label-width="90px">
        <el-form-item
          :label="item.keyName + ':'"
          v-for="(item, index) in this.list.keyList"
          :key="index"
        >
          <el-col>
            <div>
              <p>
                <!-- v-model="item['radio']" -->
                <el-radio-group
                  v-model="item['radio']"
                  :key="index"
                  @change="changeHandler(item)"
                >
                  <el-radio
                    v-for="(x, y) in item.valuesList"
                    :key="y"
                    :label="x.valuesName"
                    >{{ x.valuesName }}</el-radio
                  >
                </el-radio-group>
              </p>
            </div>
          </el-col>
        </el-form-item>

        <el-form-item label="库存">
          <el-col :span="10">
            <el-input
              v-model="skuOptions.stock"
              placeholder="请输入内容"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="价格">
          <el-col :span="10">
            <el-input
              v-model="skuOptions.price"
              type="number"
              id="number"
              oninput="value=value.replace(/[^0-9.]/g,'')"
              min="1"
              placeholder="请输入内容"
            ></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <el-button type="primary" size="small" @click="skuAdd">确定</el-button>
    </a-modal>
    <!-- 修改SKU -->
    <a-modal v-model="skuchangeVisibile" title="修改SKU" :footer="null">
      <el-form label-width="90px">
        <!-- <el-form-item
          :label="item.keyName + ':'"
          v-for="(item, index) in this.list.keyList"
          :key="index"
        >
          <el-col>
            <div>
              <p>
                <el-radio-group
                  v-model="item['radio']"
                  :key="index"
                  @change="changeHandler(item)"
                >
                  <el-radio
                    v-for="(x, y) in item.valuesList"
                    :key="y"
                    :label="x.valuesName"
                    >{{ x.valuesName }}</el-radio
                  >
                </el-radio-group>
              </p>
            </div>
          </el-col>
        </el-form-item> -->

        <el-form-item label="库存">
          <el-col :span="10">
            <el-input
              v-model="changeSkuList.stock"
              placeholder="请输入内容"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="价格">
          <el-col :span="10">
            <el-input
              v-model="changeSkuList.price"
              oninput="value=value.replace('-', '')"
              type="number"
              placeholder="请输入内容"
            ></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <el-button type="primary" size="small" @click="skuModify">确定</el-button>
    </a-modal>
    <!-- 删除弹出框 -->
    <a-modal
      :visible="delOpen"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <p>确定要删除吗？</p>
    </a-modal>
  </div>
</template>
<script>
import { baseURL } from "../../api/config";
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
export default {
  props: ["Detaildata"],
  data() {
    return {
      delOpen: false,
      imgId: "",
      bannerUrl: "",
      loadUpt: false, //加载
      serverUrl: baseURL + "/file/uploadFile",
      header: {
        // token: localStorage.getItem("key"),
      },
      //   给spu添加图片
      addImgOptinos: {
        imgUrl: "",
        sort: "",
        scGoodsId: "",
        imgType: "",
      },
      radioItem: "",
      //   给spu添加属性
      attributeOptions: {
        keyName: "",
      },
      //   给spu属性添加值
      spuOptions: {
        scGoodsKey: "",
        valuesName: "",
        valuesImg: "",
        sort: "",
      },
      skuOptions: {
        attribute: [],
        attributeValues: "",
        stock: "",
        price: "",
      },
      options: [],
      imgVisibile: false,
      attributeVisibile: false,
      spuVisibile: false, //   给spu属性添加值
      skuVisibile: false, //sku
      skuchangeVisibile: false, //修改sku
      list: [],
      spuId: "",
      radioList: [],
      changeSkuList: [],
      bannerList: [
        { imgUrl: "" },
        { imgUrl: "" },
        { imgUrl: "" },
        { imgUrl: "" },
        { imgUrl: "" },
        { imgUrl: "" },
        { imgUrl: "" },
        { imgUrl: "" },
        { imgUrl: "" },
        { imgUrl: "" },
      ],
      detailImgList: [],
      imgType: "", //上传图片的类型
    };
  },
  methods: {
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%;text-aligin:center;text-align: center;";
      } else {
        return "";
      }
    },
    addImg(val, index) {
      this.imgVisibile = true;
      this.imgType = val;
      this.addImgOptinos.sort = index + 1;
    },
    addAttribute() {
      this.attributeVisibile = true;
    },
    // 给spu添加图
    sureImgAdd() {
      this.postAxios("/goods/spu/addImg", {
        scGoodsId: this.Detaildata.id,
        imgUrl: this.addImgOptinos.imgUrl,
        imgType: this.imgType,
        sort: this.addImgOptinos.sort,
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.addImgOptinos = {
            imgUrl: "",
            sort: "",
            scGoodsId: "",
            imgType: "",
          };
          this.detailList();
        } else {
          this.$message.error(res.message);
        }
        this.imgVisibile = false;
      });
    },
    // 给spu添加属性
    sureAttributeAdd() {
      this.postAxios("/goods/spu/addKey", {
        scGoodsId: this.Detaildata.id,
        keyName: this.attributeOptions.keyName,
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.attributeOptions = {};
          this.detailList();
        } else {
          this.$message.error(res.message);
        }
        this.attributeVisibile = false;
      });
    },
    addSpuValue(row) {
      this.spuOptions.scGoodsKey = row.id;
      this.spuVisibile = true;
    },
    // 添加SKU
    addSKU() {
      this.skuVisibile = true;
    },
    cancelSku() {
      this.skuOptions={};
      this.detailList();
    },
    // 修改sku
    changeSku(row) {
      this.skuchangeVisibile = true;
      this.changeSkuList = row;
    },
    // 修改sku
    skuModify() {
      this.postAxios("/goods/sku/update", {
        id: this.changeSkuList.id,
        stock: this.changeSkuList.stock,
        price: this.changeSkuList.price,
      }).then((res) => {
        if (res.success) {
          this.skuchangeVisibile = false;
          this.$message.success(res.message);
          this.detailList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    changeHandler(val) {
      this.radioList.push(val);
      let myarr = this.radioList;

      for (var i = 0; i < myarr.length; i++) {
        for (var j = i + 1; j < myarr.length; j++) {
          if (myarr[i].id == myarr[j].id) {
            myarr.splice(i, 1);
            j--;
          }
        }
      }
      this.radioList = myarr;
      var obj = {};
      this.radioList.map((i) => {
        obj[i.keyName] = i.radio;
      });
      this.skuOptions.attribute = obj;
    },
    spuValueAdd() {
      this.postAxios("/goods/spu/addValue", {
        scGoodsKey: this.spuOptions.scGoodsKey,
        valuesName: this.spuOptions.valuesName,
        valuesImg: this.spuOptions.valuesImg,
        sort: this.spuOptions.sort,
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.spuOptions = {};
          this.detailList();
        } else {
          this.$message.error(res.message);
        }
        this.spuVisibile = false;
      });
    },
    skuAdd() {
      //   this.radioList.map((i) => {
      //     this.skuOptions.attribute.push({
      //       key: i.keyName,
      //       value: i.radio,
      //     });
      //   });
      var str = [];
      this.radioList.map((i, index) => {
        this.radioList[index].valuesList.map((x) => {
          if (x.valuesName == i.radio) {
            str.push(x.id);
          }
        });
      });
      this.skuOptions.attributeValues = str.join(";");
      this.postAxios("/goods/sku/insert", {
        scGoodsId: this.Detaildata.id,
        attributeJson: this.skuOptions.attribute,
        attributeValues: this.skuOptions.attributeValues,
        stock: this.skuOptions.stock,
        price: this.skuOptions.price,
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.skuOptions = {};
          this.detailList();
        } else {
          this.$message.error(res.message);
        }
        this.skuVisibile = false;
      });
    },
    // 上架下架
    shelves(row, val) {
      this.getAxios("/goods/sku/standAndDown", {
        skuId: row.id,
        state: val,
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.detailList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    upSuccess(file) {
      this.addImgOptinos.imgUrl = file.entity;
    },
    spuImgSuccess(file) {
      this.spuOptions.valuesImg = file.entity;
    },
    banner() {
      var mySwiper = new Swiper(".swiper-container", {
        slidesPerView: 3,
        // 如果需要前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    },
    detailList() {
      this.getAxios("/goods/spu/detail", {
        spuId: this.spuId,
      }).then((res) => {
        this.list = res.entity;
        this.options = [];
        res.entity.keyList.map((i, index) => {
          this.options.push({
            label: i.keyName,
            value: i.keyName,
            children: [],
          });
          i.valuesList.map((x, y) => {
            this.options[index].children.push({
              label: x.valuesName,
              value: x.valuesName,
            });
          });
        });

        // let obj=JSON.parse(this.list.skuList[0].attribute)
        // console.log(obj)
        // let list = [];
        // Object.getOwnPropertyNames(obj).forEach(function (key) {
        //   let o = {
        //     k: key,
        //     v: obj[key],
        //   };
        //   list.push(o);
        // });
        // console.log(list);
        this.bannerList = [
          { imgUrl: "" },
          { imgUrl: "" },
          { imgUrl: "" },
          { imgUrl: "" },
          { imgUrl: "" },
          { imgUrl: "" },
          { imgUrl: "" },
          { imgUrl: "" },
          { imgUrl: "" },
          { imgUrl: "" },
        ];
        this.detailImgList = [
          { imgUrl: "" },
          { imgUrl: "" },
          { imgUrl: "" },
          { imgUrl: "" },
          { imgUrl: "" },
          { imgUrl: "" },
          { imgUrl: "" },
          { imgUrl: "" },
          { imgUrl: "" },
          { imgUrl: "" },
        ];
        var that = this;
        this.list.rotationImgList.map((n, index) => {
          this.bannerList.splice(n.sort - 1, 1, n);
          that.$nextTick(function () {
            that.banner();
          });
        });
        this.list.detailImgList.map((i, index) => {
          this.detailImgList.splice(i.sort - 1, 1, i);
        });
      });
    },
    //不删除：
    handleCancel() {
      this.delOpen = false;
    },
    handleOk() {
      this.getAxios("/goods/spu/deleteImg", {
        imgId: this.imgId,
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.detailList();
          this.delOpen = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    deleteImg(item) {
      this.delOpen = true;
      this.imgId = item.id;
    },
  },
  mounted() {
    this.spuId = this.Detaildata.id;
    this.detailList();
  },
  watch: {
    Detaildata(newVal, oldVal) {
      this.Detaildata.id = newVal.id;
      this.spuId = newVal.id;
      this.detailList();
    },
  },
};
</script>
<style scoped lang="less">
/deep/.el-upload {
  width: 200px;
  height: auto;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  outline: 0;
  border: 2px dashed #eee;
  img {
    width: 100%;
    height: auto;
  }
}
/deep/ .el-form-item {
  width: 100%;
}
/deep/ .el-form-item__content {
  width: 100%;
}
/deep/ .ant-modal {
  width: 600px !important;
}
.swiper-container {
  height: 320px;
  line-height: 300px;
}
/deep/.swiper-slide {
  width: 300px !important; /*设为固定值*/
  height: auto !important; /*根据内容调整宽度*/
  position: relative;
}
/deep/.swiper-slide img {
  width: 200px !important; /*设为固定值*/
  height: auto !important;
}
.xuhao {
  position: absolute;
  top: -118px;
}
.detailXuhao {
  position: absolute;
  top: 0;
  left: -14px;
}
</style>